export default "__VITE_ASSET__B3rSjF4b__"